import React, { useState } from "react";
import { Button, Typography } from "@material-ui/core";
import { FileUploadErrorText } from "./StyledTexts";
import { useTranslation } from "../../langs/useTranslation";
import useStyles from "../../styles/delegationStyle";
import { GetAppOutlined } from "@material-ui/icons";
import { MissingSelectedErrorText } from "./StyledTexts";
import { downloadTemplateAPI } from "../../apis/downloadTemplateAPI";
import localforage from "localforage";
import { ProgressBar } from "react-loader-spinner";

const ExcelFileUpload = (props) => {
  const classes = useStyles();
  const { t } = useTranslation("devicesGroups");
  const { selectWay, setSelectWay, excelFile, setExcelFile } = props;
  const [fileUploadError, setFileUploadError] = useState(false);
  const excelExtension = ["xlsx", "xls", "xlsb", "csv", "xlsm"];
  const [isLoading, setIsLoading] = useState(false);

  const handleFileUpload = (e) => {
    setSelectWay("upload");
    const fileName = e.target.files[0].name;
    if (e.target.files && e.target.files[0]) {
      const fileExtension = fileName.split(".").pop();
      if (excelExtension.includes(fileExtension)) {
        setFileUploadError(false);
        setExcelFile(e.target.files[0]);
      } else {
        setFileUploadError(true);
        setExcelFile(null);
      }
    }
  };

  const handleDownloadTemplate = async () => {
    setIsLoading(true);
    const companyId = await localforage.getItem("userCompanyID");
    await downloadTemplateAPI(companyId);
    setIsLoading(false);
  };

  return (
    <>
      <div className={classes.uploadFileWrap}>
        <div className={classes.deviceExcelFileUploadMainInput}>
          <Button
            variant="outlined"
            component="label"
            onClick={() => {
              setSelectWay("upload");
            }}
          >
            <input
              type="file"
              id="fileInput"
              onChange={handleFileUpload}
              className={classes.hiddenInput}
            />
          </Button>
          <Typography
            variant="button"
            className={classes.uploadBtn}
            color="primary"
          >
            {t("setting.uploadBtn")}
          </Typography>
          {fileUploadError && (
            <FileUploadErrorText text="uploadExcelFileErrorMsg" />
          )}
          {selectWay === "upload" && excelFile === false && (
            <MissingSelectedErrorText text="selectedTargetRequired" />
          )}
        </div>
        <Button
          onClick={handleDownloadTemplate}
          variant="text"
          color="secondary"
          className={classes.downloadTemplate}
          startIcon={<GetAppOutlined color="primary" />}
        >
          {t("setting.downloadTemplateBtn")}
        </Button>
        {isLoading && (
          <ProgressBar
            height="80"
            width="80"
            ariaLabel="progress-bar-loading"
            wrapperStyle={{}}
            wrapperClass="progress-bar-wrapper"
            borderColor="#F4442E"
            barColor="#51E5FF"
          />
        )}
      </div>
    </>
  );
};

export default ExcelFileUpload;
